var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"width-100 height-100 flex-container align-center justify-center primary-background"},[_c('qrcode-vue',{attrs:{"size":300,"value":_vm.value,"class-name":"qrcode-container","level":"H"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }